import { ENV } from "../utils";

export class Meta {
  baseApi = ENV.BASE_API;

  async createMeta(accessToken, objetivoId, data) {
    try {
      const url = `${this.baseApi}/objetivos/${objetivoId}/metas`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getMetasByObjetivo(accessToken, objetivoId) {
    try {
      const url = `${this.baseApi}/objetivos/${objetivoId}/metas`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateMeta(accessToken, metaId, data) {
    try {
      const url = `${this.baseApi}/metas/${metaId}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteMeta(accessToken, metaId) {
    try {
      const url = `${this.baseApi}/metas/${metaId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async toggleOcurrencia(accessToken, metaId, ocurrenciaId, cumplida) {
    try {
      const url = `${this.baseApi}/metas/${metaId}/ocurrencias/${ocurrenciaId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ cumplida }),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadEvidence(accessToken, metaId, formData) {
    try {
      const url = `${this.baseApi}/metas/${metaId}/evidencias`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEvidence(accessToken, metaId, evidenciaId) {
    try {
      const url = `${this.baseApi}/metas/${metaId}/evidencias/${evidenciaId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // GET autenticado (Bearer header) que baja el archivo como blob y dispara
  // la descarga — un <a href> directo no serviría porque el endpoint exige
  // el header Authorization, que el navegador nunca manda en una navegación
  // o carga de <img>/<a> plana.
  async downloadEvidence(accessToken, metaId, evidenciaId, fileName) {
    const url = `${this.baseApi}/metas/${metaId}/evidencias/${evidenciaId}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) throw await response.json();

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName || "evidencia";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  }
}
